// import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LayoutPage from "./pages/LayoutPage";
import "./App.css";
// import "./bootstrap.min.css";
import "./scss/customizedBootstrap.scss";
import { GlobalDataContextProvider } from "./components/GlobalDataProvider";
import svMessages from "devextreme/localization/messages/sv.json";
import { locale, loadMessages } from "devextreme/localization";

loadMessages(svMessages);
locale("sv-SE");

function App() {
  return (
    <GlobalDataContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<LayoutPage />}></Route>
        </Routes>
      </BrowserRouter>
    </GlobalDataContextProvider>
  );
}

export default App;
